import { render, staticRenderFns } from "./SortingButtonsGroup.vue?vue&type=template&id=029559cd&"
import script from "./SortingButtonsGroup.vue?vue&type=script&lang=js&"
export * from "./SortingButtonsGroup.vue?vue&type=script&lang=js&"
import style0 from "./SortingButtonsGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports